document.addEventListener("facet:update", function () {
  const sectionRefreshMarkers = document.querySelectorAll(
    "input[name=refresh_section]",
  );

  for (const input of sectionRefreshMarkers) {
    const sectionId = input.value;
    const parentSection = input.closest(".shopify-section");
    const thisPagePath = window.location.pathname;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.append("section_id", sectionId);

    const sectionPageURL = `${thisPagePath}?${searchParams.toString()}`;
    const fetchedSection = fetch(sectionPageURL);
    fetchedSection.then((response) => response.text()).then((data) => {
      const newSection = document.createElement("div");
      newSection.innerHTML = data;
      const newSectionContent = newSection.querySelector(
        `#shopify-section-${sectionId}`,
      );
      const oldSection = parentSection 
      oldSection.innerHTML = newSectionContent.innerHTML;

      document.dispatchEvent(new CustomEvent("hc:section:refreshed", {
        detail: {
          sectionId,
          newSectionContent,
        },
      }));
    });
  }
});
